import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";
import { useEffect } from "react";
import ReactGA from "react-ga4";

import { useLocation } from "react-router-dom";

export const {
  ENV_GOOGLE_ANALYTICS
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
} = dmenv;

export const initializeAnalytics = () => {
  // only prod env
  if (!ENV_GOOGLE_ANALYTICS || process.env.NODE_ENV === "development") return;

  ReactGA.initialize(ENV_GOOGLE_ANALYTICS ?? "");

  LogRocket.init("uflrgk/comu-app");

  setupLogRocketReact(LogRocket);
};

export const trackPageView = (path: string) => {
  if (process.env.NODE_ENV === "development") return;

  ReactGA.send({ hitType: "pageview", page: path });
};

export const trackEvent = (event: string, data: Record<string, string>) => {
  if (process.env.NODE_ENV === "development") return;

  ReactGA.send({ hitType: "event", event, ...data });
};

export const trackError = (description: string, fatal = false) => {
  if (process.env.NODE_ENV === "development") return;

  ReactGA.send({ hitType: "exception", description, fatal });
};

export const AnalyticsWrapper: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};
